import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import serverClient from '../../api/ServerClient';

function LanguageToggle() {
    const { language, changeLanguage } = useLanguage();

    const toggleLanguage = () => {
        const newLanguage = language === 'en' ? 'bn' : 'en';
        changeLanguage(newLanguage);
        serverClient.put('/api/user/settings', {
            language: newLanguage,
        });
    };

    return (
        <div className="language-toggle-container">
            <button
                type="button"
                className={`language-toggle-switch ${language}`}
                onClick={toggleLanguage}
                aria-label="Toggle language"
            >
                <span className="toggle-label english-label">English</span>
                <span className="toggle-label bengali-label">বাংলা</span>
            </button>
        </div>
    );
}

export default LanguageToggle;
